var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.no_margin ? '' : 'graph-position',style:({width: _vm.width ? _vm.width : '100%', height: _vm.height ? _vm.height + 'px' : '330px'}),attrs:{"id":'pie-chart-' + _vm._uid}})}
var staticRenderFns = []

export { render, staticRenderFns }